{
	"sent": {
		"title": "Conferencia Enviada",
		"tooltip": "Conferencia de efectivo enviada a la oficina financiera."
	},
	"pending": {
		"title": "Conferencia Pendiente",
		"tooltip": "Conferencia de efectivo pendiente para ser enviada a la oficina financiera."
	},
	"openPdv": "PDVs Abiertos",
	"openTable": "Mesas al aire libre"
}
